import * as React from "react";

export interface LineHeightIconProps extends React.SVGProps<SVGSVGElement> {}

export const LineHeightIcon: React.FC<LineHeightIconProps> = ({ className, ...props }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
    aria-hidden="true"
    focusable="false"
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M6 10V5m0 0L4 7m2-2 2 2m-2 7v5m0 0 2-2m-2 2-2-2m8-10h8m0 5h-8m0 5h8"
    />
  </svg>
);
